import React, { useState } from 'react';
import styled from 'styled-components';

import Btn from '../../buttons/Btn';
import { toTitleCase } from '../helpers/helpers';

const Title = styled.p`
  font-size: 18px;
  font-weight: 800;
`;

const Header = styled.p`
  font-size: 18px;
  font-weight: 700;
`;

const Text = styled.p`
  font-size: 18px;
  font-weight: 400;
  color: #354354;
`;

const StyledBtn = styled(Btn)`
  margin: 15px 0;
`;

const Link = styled.a`
  color: #4a90e2;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

type PaymentErrorProps = {
  data?: any;
  center?: any;
  pointDate?: string;
  errorStatus?: number;
  validatePointReservation?: any;
  errorText?: string;
};
const PaymentError = ({
  data,
  center,
  pointDate,
  errorStatus,
  errorText,
  validatePointReservation,
}: PaymentErrorProps) => {
  const handlePayment = async (paymentData) => {
    validatePointReservation(paymentData.reservationId);

    if (errorStatus === 422) {
      return;
    }
    if (!paymentData || !paymentData.link || !paymentData.params) {
      return;
    }

    const form = document.createElement('form');
    form.method = 'POST';
    form.action = paymentData.link;
    form.style.display = 'none';

    Object.entries(paymentData.params).forEach(([key, value]) => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = key;
      input.value = String(value);
      form.appendChild(input);
    });

    document.body.appendChild(form);

    form.submit();

    setTimeout(() => {
      document.body.removeChild(form);
    }, 1000);
  };

  const renderErrorContent = () => {
    if (errorStatus === 409) {
      return (
        <>
          <Title>Vous êtes déjà inscrit(e) sur ce stage.</Title>
          <Text>
            Connectez-vous à votre <Link>espace personnel</Link> pour effectuer le paiement (si cela
            n'a pas déjà été fait). Un conseiller peut vous aider à finaliser votre inscription en
            quelques minutes.
          </Text>
        </>
      );
    } else if (errorStatus === 403) {
      return (
        <>
          <Title>Vous êtes déjà inscrit(e) sur ce stage.</Title>
          <Text>
            Vous avez dû recevoir un email de notre partenaire ActiROUTE. Un conseiller pourra vous
            aider à finaliser votre inscription en quelques minutes.
          </Text>
        </>
      );
    } else if (errorStatus === 422) {
      return (
        <>
          <Title>Oups ! Une erreur est survenue</Title>
          <Text>{errorText}</Text>

          <Text>
            En cas de besoin, notre partenaire ActiROUTE est à votre disposition : un conseiller
            pourra vous aider à finaliser votre inscription en quelques minutes.
          </Text>
          <StyledBtn
            color="#4a90e2"
            text="Retentez un paiement"
            onClick={() => handlePayment(data)}
          />
        </>
      );
    }
    return (
      <>
        <Title>Oups ! Une erreur est survenue</Title>
        <Text>
          Le paiement de votre stage de récupération de points prévu du {pointDate} à{' '}
          {toTitleCase(center.city)} n’a pas pu aboutir.
        </Text>
        <Header>Vous pouvez réessayer le paiement en cliquant sur le bouton ci-dessous.</Header>
        <Text>
          En cas de besoin, notre partenaire ActiROUTE est à votre disposition : un conseiller
          pourra vous aider à finaliser votre inscription en quelques minutes.
        </Text>
        <StyledBtn
          color="#4a90e2"
          text="Retentez un paiement"
          onClick={() => handlePayment(data)}
        />
      </>
    );
  };

  return (
    <div>
      {renderErrorContent()}
      <Text>
        Contactez-nous au{' '}
        <Link href="tel:0970703068" aria-label="0970703068">
          09 70 70 30 68
        </Link>{' '}
        ou par email à <Link href="email:vroomvroom@actiroute.com">vroomvroom@actiroute.com</Link>
      </Text>
      <Text>Du lundi au vendredi de 8h à 18h, le samedi de 8h30 à 12h30 et de 13h30 à 16h30.</Text>
    </div>
  );
};

export { PaymentError };
